
import React, { useState, useMemo, useRef, useEffect } from 'react';
import styles from '../../styles/GeneracionCargosManualesStyles/GeneracionCargosManuales.module.css';
import Pagination from '../../components/Pagination.tsx';

function StudentResults({ students = [], onStudentSelect }) {
  // Pagination logic (client-side)
  const [page, setPage] = useState(1);
  const pageSize = 8;
  const totalPages = Math.max(1, Math.ceil(students.length / pageSize));
  const paginated = students.slice((page - 1) * pageSize, page * pageSize);

  // Unique key for students to reset page on data change
  const studentsKey = useMemo(() => {
    return students.map(s => s.id_estudiante || s.id).sort().join(',');
  }, [students]);
  const prevStudentsKeyRef = useRef(studentsKey);
  useEffect(() => {
    if (prevStudentsKeyRef.current !== studentsKey) {
      setPage(1);
      prevStudentsKeyRef.current = studentsKey;
    }
  }, [studentsKey]);
  useEffect(() => {
    if (page > totalPages && totalPages > 0) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  // Format null/undefined values
  const formatValue = (value) => {
    if (value === null || value === undefined || value === '' || value === 'undefined') {
      return 'N/A';
    }
    return value;
  };

  // Always render the table; when there are no students show a message inside the table body

  return (
    <div className={styles.tableSection}>
      <div className={styles.tableHeader}>
        <div className={styles.tableIcon}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 className={styles.tableTitle}>Estudiantes</h3>
      </div>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Matrícula</th>
              <th>Campus</th>
              <th>Sección</th>
              <th>Programa</th>
              <th>Ciclo Escolar</th>
            </tr>
          </thead>
          <tbody>
            {paginated.length > 0 ? (
              paginated.map((student, index) => (
                <tr
                  key={student.id || student.id_estudiante}
                  className={index % 2 === 0 ? styles.evenRow : styles.oddRow}
                  onClick={() => onStudentSelect(student)}
                  style={{ cursor: 'pointer' }}
                >
                  <td className={styles.nameCell}>{formatValue(student.nombre || student.nombre_completo)}</td>
                  <td>{formatValue(student.matricula)}</td>
                  <td>{formatValue(student.campus || student.campus_nombre)}</td>
                  <td>{formatValue(student.seccion)}</td>
                  <td>{formatValue(student.programa || student.programa_nombre)}</td>
                  <td>{formatValue(student.cicloEscolar || student.ciclo_escolar_nombre)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', padding: '24px 12px' }} className={styles.noResults}>
                  No se encontraron estudiantes con los criterios de búsqueda.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
}

export default StudentResults;
